/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserMarketplacePricingRuleResponseDTO interface.
 */
export function instanceOfUserMarketplacePricingRuleResponseDTO(value) {
    return true;
}
export function UserMarketplacePricingRuleResponseDTOFromJSON(json) {
    return UserMarketplacePricingRuleResponseDTOFromJSONTyped(json, false);
}
export function UserMarketplacePricingRuleResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ruleId': json['ruleId'] == null ? undefined : json['ruleId'],
        'ruleName': json['ruleName'] == null ? undefined : json['ruleName'],
        'selected': json['selected'] == null ? undefined : json['selected'],
    };
}
export function UserMarketplacePricingRuleResponseDTOToJSON(json) {
    return UserMarketplacePricingRuleResponseDTOToJSONTyped(json, false);
}
export function UserMarketplacePricingRuleResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ruleId': value['ruleId'],
        'ruleName': value['ruleName'],
        'selected': value['selected'],
    };
}
